module.exports = __webpack_public_path__ + "static/img/2.34fdc77d.jpg";